export default __webpack_public_path__ + "static/media/stern_weiss.d313aaed.png";